import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=0b1d87f7&scoped=true&"
import script from "./EmptyLayout.vue?vue&type=script&lang=ts&"
export * from "./EmptyLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1d87f7",
  null
  
)

export default component.exports